<template lang="pug">
    v-card(
        outlined
        tile
        style="padding: 0 !important; display: flex; flex-direction: column; height: 100%;"
    )
        v-card-text(style="flex: 1; overflow: auto; padding-bottom: 0;")
            .text-center(v-if="isLoading")
                v-progress-circular(
                    :size='100'
                    :width='10'
                    color='var(--volie-blue)'
                    indeterminate
                    style="margin-top: 100px;"
                )
            
            div(v-else-if="!validCurrentSurveyTemplate")
                | Something went wrong

            div(v-else)
                div(v-if="hasMultipleSurveyTemplates")
                    v-tabs(v-model='currentTab' fixed-tabs)
                        v-tab(v-for='item in tabs' :key='item.key' :href="item.href")
                            | {{ item.name }}
                        v-menu(v-if='moreTabs.length' bottom left)
                            template(v-slot:activator='{ on }')
                                v-btn.align-self-center.mr-4(text v-on='on')
                                    | more
                                    v-icon(right) mdi-menu-down
                            v-list.grey.lighten-5
                                v-list-item(v-for='item in moreTabs' :key='item.key' @click='addMoreItem(item)')
                                    | {{ item.name }}

                    v-tabs-items
                        CurrentSurveyTemplate.my-md-4(
                            style="overflow-y: auto;"
                            :set-survey="setSurvey"
                            :survey-template="currentSurveyTemplate"
                        )

                div(v-else)
                    CurrentSurveyTemplate(
                        style="overflow-y: auto;"
                        :set-survey="setSurvey"
                        :survey-template="currentSurveyTemplate"
                    )

        v-footer.font-weight-medium.no-padding
            v-col.text-center.no-padding(cols='12')
                v-container.no-padding-bottom(fluid)
                    div.text-right.mb-1
                        div.mb-1
                            CopyButton(
                                :text="dispositionNotes"
                            )
                        v-textarea(
                            v-model="dispositionNotes"
                            label='Type notes'
                            rows="1"
                            auto-grow
                            clearable
                            counter
                            filled
                            outlined
                            dense
                        )
</template>

<script lang="ts">
    import Vue from 'vue';

    // Components
    import CurrentSurveyTemplate from '@/components/communication_center/shared/current_survey_template.vue';
    import CopyButton from '@/components/shared/copy_text_button.vue';

    // Data
    import { GetCommunicationCenterSurveyTemplates } from "@/data";

    export default Vue.extend({
        data() {
            return {
                currentSurveyTemplate: null,
                currentTab: null,
                dispositionNotes: null,
                isLoading: false,
                moreTabs: [],
                survey: null,
                surveyTemplates: [],
                tabs: [],
            }
        },
        methods: {
            addMoreItem(item) {
                const removed = this.tabs.splice(0, 1);
                this.tabs.push(
                    ...this.moreTabs.splice(this.moreTabs.indexOf(item), 1)
                );
                this.moreTabs.push(...removed);
                this.$nextTick(() => {
                    this.currentTab = item.href;
                    this.handleCurrentTabChange();
                });
            },
            buildTabs() {

                // If there are not more than 1 template, abort
                if (!(this.surveyTemplates?.length > 1) || !this.currentSurveyTemplate) {
                    return;
                }

                for (let i = 0; i < this.surveyTemplates.length; i++) {

                    // Init
                    const surveyTemplate = this.surveyTemplates[i];
                    if (!surveyTemplate || !(surveyTemplate.survey_template_id > 0)) {
                        continue;
                    }

                    const tab = {
                        name: surveyTemplate.survey_template_name + " (" + surveyTemplate.language_abbreviation_code + ")",
                        key: "st-" + surveyTemplate.survey_template_id.toString(),
                        href: "#st-tab-" + surveyTemplate.survey_template_id.toString()
                    }

                    // If current template, add to main tabs array
                    if (this.currentSurveyTemplate.survey_template_id === surveyTemplate.survey_template_id) {
                        this.tabs.push(tab);
                    } else {
                        this.moreTabs.push(tab);
                    }
                }

                // // Set new component height
                // Vue.nextTick(() => { this.setSurveyTemplateHeight(); });
            },
            changeCurrentSurveyTemplate() {

                // Verify current tab is present
                if (!(this.currentTab?.length > 0) || !(this.surveyTemplates?.length > 0)) {
                    return;
                }

                // Split and verify 2 pieces
                const pieces = this.currentTab.split("st-tab-");
                if (!(pieces?.length === 2)) {
                    return;
                }

                // Parse
                const surveyTemplateID = parseInt(pieces[1]);
                if (!(surveyTemplateID > 0)) {
                    return;
                }

                // Loop through and match to survey template
                for (let i = 0; i < this.surveyTemplates.length; i++) {

                    // Init
                    const surveyTemplate = this.surveyTemplates[i];
                    if (!surveyTemplate || !(surveyTemplate.survey_template_id > 0)) {
                        continue;
                    }

                    // If we do not have a match, continue looping
                    if (surveyTemplate.survey_template_id !== surveyTemplateID) {
                        continue;
                    }

                    // Set as current
                    this.currentSurveyTemplate = { ...surveyTemplate };
                    this.isLoading = false;
                    break;
                }
            },
            getCommunicationCenterSurveyTemplates(showLoader) {
                const options = {
                    campaign_customer_id: (this.campaignCustomerId || 0),
                    campaign_id: (this.campaignId || 0),
                }

                // Only show on created
                if (showLoader) {
                    this.isLoading = true;
                }

                GetCommunicationCenterSurveyTemplates(options).then((response) => {
                    if (response?.Data?.survey_templates?.length > 0) {

                        // If we already have templates, then we just need to do a text refresh so we do not lose progress on the answers
                        if (this.surveyTemplates?.length > 0) {
                            this.refreshAllTemplateTexts(response.Data.survey_templates);
                        } else {

                            // Set current first so that it is already present when build tabs runs from watcher
                            this.currentSurveyTemplate = { ...response.Data.survey_templates[0] };

                            // Set survey templates
                            this.surveyTemplates = response.Data.survey_templates;
                        }
                    }
                    this.isLoading = false;
                });
            },
            handleCurrentTabChange() {

                // Set loader and remove current
                this.isLoading = true;
                this.currentSurveyTemplate = null;

                // Set new current
                Vue.nextTick(() => { this.changeCurrentSurveyTemplate(); });
            },
            refreshAllTemplateTexts(surveyTemplates) {

                // Verify
                if (!(surveyTemplates?.length > 0) || !(this.surveyTemplates?.length > 0)) {
                    return;
                }

                // Loop through new templates and set text
                for (let i = 0; i < surveyTemplates.length; i++) {

                    // Init
                    const iSurveyTemplate = surveyTemplates[i];
                    if (!iSurveyTemplate || !(iSurveyTemplate.survey_template_id > 0)) {
                        continue;
                    }

                    // Loop through existing templates
                    for (let j = 0; j < this.surveyTemplates.length; j++) {

                        // Init
                        const jSurveyTemplate = this.surveyTemplates[j];
                        if (!jSurveyTemplate || !(jSurveyTemplate.survey_template_id > 0)) {
                            continue;
                        }

                        // Ensure i and j are the same
                        if (iSurveyTemplate.survey_template_id !== jSurveyTemplate.survey_template_id) {
                            continue;
                        }

                        // Set statements
                        this.refreshTemplateTexts(iSurveyTemplate, jSurveyTemplate);
                    }

                    // Need to check scoped template as well since they are not the same in memory
                    if (this.currentSurveyTemplate?.survey_template_id > 0 && this.currentSurveyTemplate?.survey_template_id === iSurveyTemplate.survey_template_id) {
                        this.refreshTemplateTexts(iSurveyTemplate, this.currentSurveyTemplate);
                    }
                }
            },
            refreshTemplateTexts(newSt, oldSt) {

                // Ensure i and j are the same and valid
                if (!newSt || !oldSt || !(newSt.survey_template_id > 0) || newSt.survey_template_id !== oldSt.survey_template_id) {
                    return;
                }

                // Set statements
                oldSt.closing_statement = newSt.closing_statement;
                oldSt.opening_statement = newSt.opening_statement;

                // Determine if we need to loop through questions
                if (newSt.survey_template_questions?.length > 0 && oldSt.survey_template_questions?.length > 0) {

                    // Loop through questions
                    for (let i = 0; i < newSt.survey_template_questions.length; i++) {

                        // Init
                        const iQuestion = newSt.survey_template_questions[i];
                        if (!iQuestion || !(iQuestion.survey_template_question_id > 0)) {
                            continue;
                        }

                        // Loop through existing templates
                        for (let j = 0; j < oldSt.survey_template_questions.length; j++) {

                            // Init
                            const jQuestion = oldSt.survey_template_questions[j];
                            if (!jQuestion || !(jQuestion.survey_template_question_id > 0)) {
                                continue;
                            }

                            // Ensure i and j are the same
                            if (iQuestion.survey_template_question_id !== jQuestion.survey_template_question_id) {
                                continue;
                            }

                            // Set texts
                            jQuestion.agent_prompt = iQuestion.agent_prompt;
                            jQuestion.question_text = iQuestion.question_text;
                        }
                    }
                }
            },
            // setSurveyTemplateHeight() {
            //     const cardPadding = 12;
            //     const tabHeight = 64;
            //     const footerHeight = (this.$refs?.smsMessageSoftphoneFooterCol?.clientHeight || 78);
            //     this.surveyTemplateHeight = (this.surveyHeight - cardPadding - footerHeight);

            //     // If we have the tabs rendered, need to account for that height
            //     if (this.hasMultipleSurveyTemplates) {
            //         this.surveyTemplateHeight -= tabHeight;
            //     }
            // },
        },
        computed: {
            hasMultipleSurveyTemplates() {
                return this.surveyTemplates?.length > 1;
            },
            validCurrentSurveyTemplate() {
                return this.currentSurveyTemplate?.survey_template_id > 0;
            },
        },
        components: {
            CopyButton,
            CurrentSurveyTemplate,
        },
        props: {
            campaignCustomerId: Number,
            campaignId: Number,
            parentDispositionNotes: String,
            setSurvey: Function,
            surveyHeight: Number,
            syncDispositionNotes: Function,
        },
        destroyed() {
            this.setSurvey(null);
        },
        created() {
            this.getCommunicationCenterSurveyTemplates(true);
        },
        mounted() {
            // this.setSurveyTemplateHeight();
        },
        watch: {
            campaignCustomerId() {
                // If we now have a campaign customer ID but we didn't before, then this would be a manual mode call / inbound call / return vmr
                // So we need to reload the survey templates and just refresh the text so that the notes/answers do not get reset
                if (this.campaignCustomerId > 0) {
                    this.getCommunicationCenterSurveyTemplates(false);
                }
            },
            dispositionNotes() {
                this.syncDispositionNotes(this.dispositionNotes);
            },
            // newMessageBody() {
            //     Vue.nextTick(() => { this.setSurveyTemplateHeight(); });
            // },
            parentDispositionNotes() {
                if (this.parentDispositionNotes !== this.dispositionNotes) {
                    this.dispositionNotes = this.parentDispositionNotes;
                }
            },
            // surveyHeight() {
            //     Vue.nextTick(() => { this.setSurveyTemplateHeight(); });
            // },
            surveyTemplates() {
                this.buildTabs();
            },
        },
    });
</script>

<style lang="scss" scoped>
</style>